import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { Nav } from "./components/site/Nav";
import { Footer } from "./components/site/Footer";
import { FloatingWhatsApp } from "./components/site/FloatingWhatsApp";
import { SmoothScroll } from "./components/site/SmoothScroll";
import { ChatAssistant } from "./components/site/ChatAssistant";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Book from "./pages/Book";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";

const Layout = () => (
  <>
    <Nav />
    <Outlet />
    <Footer />
    <FloatingWhatsApp />
    <ChatAssistant />
  </>
);

function App() {
  return (
    <div className="App grain bg-[#07040D]">
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/book" element={<Book />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#150C28", border: "1px solid rgba(212,175,55,.35)", color: "#F8FAFC" } }} />
    </div>
  );
}

export default App;
